import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { newMedidasProductosSchema } from '@/shared';
import { useCreateMedidaProducto, useUpdateMedidaProducto } from '@/shared/actions/erp';
import {
  CustomTextField,
  SampleCheckbox,
  SingleFormBoxScene,
} from '@/shared/components/ui';
import { MEDIDASPRODUCTOS } from '@/shared/interfaces/erp/inventario';

const returnUrlMedidas = '/inventario/medidas-productos/';

export interface SaveMedidasProductosInterface {
  titlePage: string;
  editMedidaProducto?: MEDIDASPRODUCTOS;
}

type SaveFormData = {
  nombre: string;
  siglas: string;
  estado: boolean;
};

const SaveMedidasProductoPage: React.FC<SaveMedidasProductosInterface> = ({ titlePage, editMedidaProducto }) => {
  const navigate = useNavigate();
  const [shrink, setShrink] = useState(false);

  ///* mutations
  const createMedidasProductosMutation = useCreateMedidaProducto({navigate, returnUrl:returnUrlMedidas});
  const updateMediasProductosMutation = useUpdateMedidaProducto({navigate, returnUrl:returnUrlMedidas});

  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newMedidasProductosSchema),
    defaultValues: {
      estado: false,
    },
  });
  const {
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = form;

  ///* handlers
  const onSave = () => {
    if (!isValid) return;

    ///* upd
    if (editMedidaProducto?.id_unidad_medida) {
      return updateMediasProductosMutation.mutate({
        id: editMedidaProducto.id_unidad_medida,
        data: form.getValues() as any, // percent
      });
    }

    ///* create
    return createMedidasProductosMutation.mutate(form.getValues() as any);
  };

  ///* effects
  useEffect(() => {
    if (editMedidaProducto) {
      setShrink(true);
      reset({
      ...editMedidaProducto
      } as any);
    }
  }, [editMedidaProducto]);

  return (
    <SingleFormBoxScene
      titlePage={titlePage}
      onCancel={() => {
        navigate(returnUrlMedidas);
      }}
      onSave={handleSubmit(onSave)}
    >
      <CustomTextField
        label="Nombre"
        name='nombre'
        error={errors.nombre}
        helperText={errors.nombre?.message}
        shrink={shrink}
        control={form.control}
      />
      <CustomTextField
        label="Siglas"
        name='siglas'
        error={errors.siglas}
        helperText={errors.siglas?.message}
        shrink={shrink}
        control={form.control}
        />
      {/* ====== state ====== */}
      <SampleCheckbox
        label="Estado"
        name="estado"
        control={form.control}
        defaultValue={!!form.getValues().estado}
        isState
      />
    </SingleFormBoxScene>
  );
};

export default SaveMedidasProductoPage;
